// Entry modes are explicit. Cart validation and durable retries remain shared.
import { createCartHandoff } from './marinas-cart-handoff.js';

const installed = new WeakMap();
export function installGoliCheckoutPreview(win, options = {}) {
  if (installed.has(win.document)) return installed.get(win.document);
  const settings = win.GoliTheme?.checkoutPreview;
  const mode = win.GoliTheme?.checkoutEntryMode ?? win.document.body.dataset.checkoutEntryMode ?? (settings === undefined || settings?.enabled === false ? 'native' : 'preview');
  if (mode === 'native') return () => {};
  const commerce = win.GoliCommerce;
  if (typeof commerce?.setCheckoutHandler !== 'function') throw new Error('The cart is not ready for checkout. Please refresh this page.');
  let client;
  let disposed = false;
  const checkPreview = () => {
    if (!['preview', 'production'].includes(mode) || mode === 'preview' && settings?.enabled !== true || typeof settings?.proxyPath !== 'string' || typeof settings?.designMode !== 'boolean') throw new Error('The checkout entry configuration is unavailable. Please contact the store.');
    if (settings.designMode || win.Shopify?.designMode) throw new Error('Open this unpublished theme preview in a separate tab to test checkout.');
    const role = win.Shopify?.theme?.role;
    if (mode === 'preview' ? role !== 'unpublished' : !['main', 'unpublished'].includes(role)) throw new Error('This checkout connection is unavailable for this theme role. Your cart has been kept.');
    if (disposed) throw new Error('The checkout preview changed. Please refresh this page.');
  };
  commerce.setCheckoutHandler(async expectedQuantity => {
    checkPreview();
    client ||= createCartHandoff({
      proxy: settings.proxyPath,
      root: win.GoliTheme?.routesRoot || '/',
      storage: win.sessionStorage,
      fetcher: (...args) => win.fetch(...args),
      random: win.crypto,
      ...(options.timeoutMs ? { timeoutMs: options.timeoutMs } : {}),
    });
    const destination = await client.start(expectedQuantity, { requiredCapabilities: mode === 'production' ? ['productionCheckoutSupported'] : [] });
    checkPreview();
    (options.navigate || (url => win.location.assign(url)))(destination);
  });
  const remove = () => { disposed = true; commerce.setCheckoutHandler(null); installed.delete(win.document); };
  installed.set(win.document, remove);
  return remove;
}

if (typeof window !== 'undefined') {
  if (window.GoliCommerce) installGoliCheckoutPreview(window);
  else document.addEventListener('goli:commerce-ready', () => installGoliCheckoutPreview(window), { once: true });
}
